import React from "react";
import { Spacing, Modal, Paragraph, Button, Layout } from "@sicredi/react";
import { logoutHandler } from "#/utils/logoutHandler";

interface LogoutConfirmationProp {
  logout: any;
  logoutModalOpen: any;
  setLogoutModalOpen: any;
}

export default function LogoutConfirmation({
  logout,
  logoutModalOpen,
  setLogoutModalOpen,
}: LogoutConfirmationProp) {
  return (
    <Modal
      title=""
      show={logoutModalOpen}
      onClose={() => setLogoutModalOpen(false)}
      className="requestsentmodal"
    >
      <Spacing appearance="xxx-small" />
      <div className="flexcolumn">
        <Spacing appearance="medium" />
        <Paragraph className="termstitle">Sair da conta</Paragraph>
        <Spacing appearance="small" />
        <Paragraph className="termssubtitle">
          Ao sair da sua conta, você será redirecionado de volta para a página
          inicial do Shopping. Tem certeza de que deseja sair?
        </Paragraph>
      </div>

      <Spacing appearance="medium" />
      <Layout.Wrapper style={{ flexDirection: "row" }}>
        <Button
          appearance="secondary"
          onClick={() => setLogoutModalOpen(false)}
          style={{ height: "50px", marginRight: "7px" }}
        >
          Não
        </Button>
        <Button
          appearance="primary"
          onClick={() => logoutHandler(logout)}
          style={{ height: "50px", marginLeft: "7px" }}
        >
          Sim
        </Button>
      </Layout.Wrapper>
    </Modal>
  );
}
